// @ts-nocheck
/* eslint-disable */
export default class Melown3dLayer {
	/**
	 * Vytvoreni vrstvy ve 3d, ktera dokaze zobrazovat markery.
	 */
	constructor() {
		this._dom = {
			cont: null
		};
		this._presenter = null;
		this._melownCore = null;
		this._markers = [];
		this._postMarkers = [];
		// defaultni rozmisteni
		this._repositionCb = this._reposition;
		this._lastMoveMarker = null;
		this._active = false;
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		if (this._presenter) {
			this._presenter.removeListener("card-closed", this._cardClosed, this);
		}

		this._presenter = null;
		this._melownCore = null;
		this._markers = [];
	}

	/**
	 * Povoleni vrstvy.
	 */
	enable() {
		if (this._active) { return this; }

		this._active = true;
		this.redraw();

		return this;
	}

	/**
	 * Zakazani vrstvy.
	 */
	disable() {
		if (!this._active) { return this; }

		this._active = false;
		this.redraw();

		return this;
	}

	/**
	 * Je vrstva aktivni?
	 *
	 * @return {Boolean}
	 */
	isActive() {
		return this._active;
	}

	/**
	 * Pri pridani do 3d se zavola - dulezite instance pro samostatne vykresleni.
	 *
	 * @param {Melown3d} presenter
	 * @param {Object} melownCore
	 */
	setOwner(presenter, melownCore) {
		this._presenter = presenter;
		this._melownCore = melownCore;

		this._dom.cont = presenter.getContainer();

		while (this._postMarkers.length) {
			let marker = this._postMarkers.pop();

			this._setMarker(marker);
		}

		presenter.addListener("card-closed", this._cardClosed, this);
	}

	/**
	 * Kliknuti na vrstvu na souradnice x a y.
	 * Pokud vracim true -> prerusim propagaci do dalsich vrstev
	 *
	 * @param  {Number} x
	 * @param  {Number} y
	 * @return {Boolean}
	 */
	click(x, y) {
		let marker = this.getMarker(x, y);

		if (marker) {
			return marker.click();
		}
	}

	/**
	 * Pohyb pres vrstvu na souradnicich x a y.
	 * Pokud vracim true -> prerusim propagaci do dalsich vrstev
	 *
	 * @param  {Number} x
	 * @param  {Number} y
	 * @return {Boolean}
	 */
	move(x, y) {
		let marker = this.getMarker(x, y);

		if (marker) {
			this.addPointerCursor();

			if (this._lastMoveMarker && this._lastMoveMarker == marker) {
				this._lastMoveMarker.stillEnter();
				return true;
			}
			else if (this._lastMoveMarker && this._lastMoveMarker != marker) {
				this._lastMoveMarker.mouseLeave();
			}

			this._lastMoveMarker = marker;

			return marker.mouseEnter();
		}
		else {
			this.removePointerCursor();

			if (this._lastMoveMarker) {
				this._lastMoveMarker.mouseLeave();
			}

			this._lastMoveMarker = null;
		}
	}

	/**
	 * Prekresleni vrstvy. Nevolat primo!!!
	 */
	render() {
		if (!this._markers.length || !this._melownCore) return;

		let size = this._melownCore.renderer.getCanvasSize();
		let pos = this._presenter.getPosition();
		let visible = [];

		this._markers.forEach(marker => {
			// spocitame a zjistime, jestli je marker viditelny
			if (marker.calc(size[0], size[1], pos)) {
				visible.push(marker);
			}
		});

		if (!visible.length) return;

		if (typeof this._repositionCb === "function") {
			visible = this._repositionCb(visible);
		}

		// volna vrstva + markery - fix z indexu
		let tmpState = this._melownCore.renderer.createState({});
		this._melownCore.renderer.setState(tmpState);

		// kresleni
		this._drawMarkers(visible, pos);
	}

	/**
	 * Prekresleni vrstvy zavola prekresleni primo na rodici - presenteru.
	 */
	redraw() {
		if (this._presenter) {
			this._presenter.redraw();
		}
	}

	/**
	 * Nastaveni vlastni funkce pro rozmistovani POIu.
	 *
	 * @param {Function} cb Vlastni funkce
	 */
	setReposition(cb) {
		this._repositionCb = cb;
	}

	/**
	 * Ziskani markeru na souradnicich x a y
	 *
	 * @param  {Number} x Hodnota na ose
	 * @param  {Number} y Hodnota na ose
	 * @return {Melown3dMarker|Array[Melown3dMarker]}
	 */
	getMarker(x, y) {
		let findMarkers = [];
		let len = this._markers.length - 1;

		for (let i = len; i >= 0; i--) {
			let marker = this._markers[i];

			if (marker.visible && marker.isIntersection(x, y)) {
				findMarkers.push(marker);
			}
		}

		return this._getHighestMarker(findMarkers);
	}

	/**
	 * Pridani markeru do vrstvy.
	 *
	 * @param {Melown3dMarker|Array[Melown3dMarker]} marker Markery
	 * @param {Boolean} noRedraw Neprekreslovat vrstvu
	 */
	addMarker(marker, noRedraw) {
		let markers = Array.isArray(marker) ? marker : [marker];

		markers.forEach(item => {
			this._addMarker(item);
		});

		if (!noRedraw) this.redraw();
	}

	/**
	 * Odebrani markeru z vrstvy.
	 *
	 * @param {Melown3dMarker|Array[Melown3dMarker]} marker Markery
	 * @param {Boolean} noRedraw Neprekreslovat vrstvu
	 */
	removeMarker(marker, noRedraw) {
		let markers = Array.isArray(marker) ? marker : [marker];
		let len = this._markers.length - 1;

		for (let i = len; i >= 0; i--) {
			let item = this._markers[i];
			let ind = markers.indexOf(item);

			if (ind != -1) {
				markers.splice(ind, 1);
				this._removeMarker(item);
				this._markers.splice(i, 1);
			}
		}

		if (!noRedraw) this.redraw();
	}

	/**
	 * Odstraneni vsech entit.
	 */
	removeAll() {
		this._markers = [];

		this.redraw();
	}

	/**
	 * Ziskani vsech entit.
	 *
	 * @return {Array}
	 */
	getEntities() {
		return this._markers;
	}

	/**
	 * Prida hlavnimu 3d rodici kurzor - prst.
	 */
	addPointerCursor() {
		if (this._dom.cont) {
			this._dom.cont.classList.add("cur-pointer");
		}
	}

	/**
	 * Odebere hlavnimu 3d rodici kurzor - prst.
	 */
	removePointerCursor() {
		if (this._dom.cont) {
			this._dom.cont.classList.remove("cur-pointer");
		}
	}

	/**
	 * Pridani markeru - pokud je vrstva jiz pripnuta, tak se prida zrovna, jinak se
	 * bude ceka na setOwner.
	 *
	 * @param {Melown3dMarker} marker Marker
	 */
	_addMarker(marker) {
		this._markers.push(marker);

		if (this._presenter) {
			this._setMarker(marker);
		}
		else {
			this._postMarkers.push(marker);
		}
	}

	/**
	 * Odebrani markeru.
	 *
	 * @param {Melown3dMarker} marker Marker
	 */
	_removeMarker(marker) {
		marker.setOwner(null);
	}

	/**
	 * Nastaveni markeru
	 *
	 * @param {Melown3dMarker} marker Marker
	 */
	_setMarker(marker) {
		marker.setOwner(this, this._presenter, this._melownCore);
	}

	/**
	 * Projdeme vsechny viditelne markery - po vyredeni nechame pouze urcitou mnozinu; zbytku musime dat .hide(true) - skryjeme je
	 *
	 * @param  {Array} visible Mnozina pouze viditelnych markeru, ktere je mozne vytridit.
	 * @return {Array} Vysledna mnozina protridenych markeru
	 */
	_reposition(visible) {
		let allBBoxes = [];
		let reducedItems = [];

		// vzdycky viditelne polozky
		let count = visible.length - 1;

		for (let i = count; i >= 0; i--) {
			let marker = visible[i];

			if (marker.getAlwaysVisible()) {
				reducedItems.push(marker);

				allBBoxes.push({
					bbox: marker.getBBox()
				});

				// odstranime
				visible.splice(i, 1);
			}
		}

		// zbytek viditelnych
		visible.forEach(marker => {
			let find = null;

			allBBoxes.every(bb => {
				if (this._isBBOXintersection(marker.getBBox(), bb.bbox)) {
					find = bb;
					return false;
				}
				else {
					return true;
				}
			});

			if (find) {
				// skryjeme
				marker.hide(true);

				// mergneme bboxy
				find.bbox = this._mergeBBOX(find.bbox, marker.getBBox());
			}
			else {
				allBBoxes.push({
					bbox: marker.getBBox()
				});

				reducedItems.push(marker);
			}
		});

		return reducedItems;
	}

	/**
	 * Merge dvou bboxu, vraci jejich vysledny bbox.
	 *
	 * @param  {Object} bbox1 Bounding box 1
	 * @param  {Object} bbox2 Bounding box 2
	 * @return {Object}
	 */
	_mergeBBOX(bbox1, bbox2) {
		return {
			lbx: Math.min(bbox1.lbx, bbox2.lbx),
			lby: Math.min(bbox1.lby, bbox2.lby),
			rtx: Math.max(bbox1.rtx, bbox2.rtx),
			rty: Math.max(bbox1.rty, bbox2.rty)
		};
	}

	/**
	 * Test pruseciku 2 bboxu.
	 *
	 * @param  {Object} bbox1 Bounding box 1
	 * @param  {Object} bbox2 Bounding box 2
	 * @return {Boolean}
	 */
	_isBBOXintersection(bbox1, bbox2) {
		return !(bbox2.lbx > bbox1.rtx
			|| bbox2.rtx < bbox1.lbx
			|| bbox2.rty < bbox1.lby
			|| bbox2.lby > bbox1.rty);
	}

	/**
	 * Event zavreni karty primo z presenteru.
	 */
	_cardClosed() {
		if (this._lastMoveMarker) {
			this._lastMoveMarker.mouseLeave();
		}

		this._lastMoveMarker = null;
	}

	/**
	 * Setrizeni markeru v zavislosti na jejich hloubce (u 2..n polozek) a vraceni toho nejvyssiho.
	 * Kdyz neni zapnuto trideni, tak pri kliku chceme dostat ten markeru, ktery je nejvysse.
	 * Nejvyssi zindex.
	 *
	 * @param  {Array} markers Vstupni data s markery
	 * @return {Melown3dMarker} Vysledny marker
	 */
	_getHighestMarker(markers) {
		if (!markers || !markers.length) {
			return null;
		}
		else if (markers.length == 1) {
			return markers[0];
		}
		else {
			// sort
			return markers.sort((a, b) => {
				return (a.getDepth() - b.getDepth());
			})[0];
		}
	}

	// kresleni markeru
	_drawMarkers(visibleMarkers, pos) {
		// pre render - napr. pro nozicky
		visibleMarkers.forEach(marker => {
			marker.preRender(this._melownCore.renderer, pos);
		});

		// hlavni cast renderu
		visibleMarkers.forEach(marker => {
			marker.render(this._melownCore.renderer, pos);
		});
	}
}
